export const CARRY_OVER_FIELDS = [
  'name', 'categoryId', 'settlementDays', 'country', 'status', 'legalName', 'incorporatedYear',
  'taxId', 'website', 'contactName', 'contactEmail', 'contactPhone', 'address', 'currency',
  'companySize', 'city', 'rootAccountName', 'loginEmail', 'notes', 'successRedirectUrl',
  'failureRedirectUrl', 'whitelistedIps', 'kycStatus',
] as const;
